export const messages = {
  en: {
    addAuditUserStep: {
      title: 'Add Audit User',
      steps: {
        branch: 'Select Branch',
        department: 'Select Department',
        staff: 'Select Staff',
        info: 'Additional Info'
      },
      buttons: {
        prev: 'Previous',
        next: 'Next',
        finish: 'Finish'
      },
      form: {
        userId: 'User ID',
        userName: 'User Name',
        auditLink: 'Audit Link',
        auditLinkOptions: {
          manager: 'Department Manager',
          finance: 'Finance Manager',
          purchase: 'Purchaser',
          complaint: 'Complaint Handler'
        },
        processObj: 'Process Object',
        processObjOptions: {
          purchase: 'Purchase Process',
          outbound: 'Outbound Process',
          complaint: 'Complaint Process'
        },
        required: 'Required',
        invalidFormat: 'Invalid format'
      },
      messages: {
        selectRequired: 'Please select or fill required information',
        success: 'Processed successfully',
        fail: 'Processing failed'
      }
    }
  },
  zh: {
    addAuditUserStep: {
      title: '添加审核人员',
      steps: {
        branch: '选择分公司',
        department: '选择部门',
        staff: '选择员工',
        info: '扩展信息'
      },
      buttons: {
        prev: '上一步',
        next: '下一步',
        finish: '完成'
      },
      form: {
        userId: '用户ID',
        userName: '用户名称',
        auditLink: '审核环节',
        auditLinkOptions: {
          manager: '部门主管',
          finance: '财务主管',
          purchase: '采购人员',
          complaint: '投诉处理人员'
        },
        processObj: '流程对象',
        processObjOptions: {
          purchase: '采购流程',
          outbound: '出库流程',
          complaint: '投诉流程'
        },
        required: '必填',
        invalidFormat: '格式错误'
      },
      messages: {
        selectRequired: '请选择或填写必选信息',
        success: '处理成功',
        fail: '处理失败'
      }
    }
  }
}